import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { NewCaseModal } from "./Modal";
import { useNewCaseForm } from "./useNewCaseForm";

export const NewCase = () => {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const newCaseForm = useNewCaseForm();

  useEffect(() => {
    setIsOpen(true);
  }, []);

  const handleClose = () => {
    setIsOpen(false);
    navigate("/due-diligence");
    newCaseForm.resetForm();
  };

  return (
    <NewCaseModal
      isOpen={isOpen}
      onClose={handleClose}
      formData={newCaseForm.formData}
      errors={newCaseForm.errors}
      isLoading={newCaseForm.isLoading}
      submitAttempts={newCaseForm.submitAttempts}
      onInputChange={newCaseForm.handleInputChange}
      onSubmit={newCaseForm.handleSubmit}
    />
  );
};
